module.exports = __webpack_public_path__ + "static/media/Week 6 Wednesday.c911348b.png";